import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords,
  image,
  type = 'website',
  noindex = false
}) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const currentLang = i18n.language || 'fr';
  
  const siteName = 'Alexandre SANOU';
  const defaultTitle = 'Alexandre SANOU | Full Stack Data Scientist';
  const defaultDescription = currentLang === 'fr' 
    ? 'Portfolio de Alexandre SANOU, Full Stack Data Scientist spécialisé en IA, Machine Learning et développement web. Consultant freelance à Paris.'
    : 'Portfolio of Alexandre SANOU, Full Stack Data Scientist specialized in AI, Machine Learning and web development. Freelance consultant in Paris.';
  const defaultKeywords = currentLang === 'fr'
    ? 'Data Scientist, Machine Learning, IA, Intelligence Artificielle, Python, React, Consultant, Freelance, Paris'
    : 'Data Scientist, Machine Learning, AI, Artificial Intelligence, Python, React, Consultant, Freelance, Paris';
  const defaultImage = '/logo512.png';
  const baseUrl = process.env.REACT_APP_PUBLIC_URL;
  const hasPublicUrl = Boolean(baseUrl);

  const fullTitle = title ? `${title} | ${siteName}` : defaultTitle;
  const canonicalUrl = hasPublicUrl ? `${baseUrl}${location.pathname}` : null;

  return (
    <Helmet htmlAttributes={{ lang: currentLang }}>
      <title>{fullTitle}</title>
      <meta name="description" content={description || defaultDescription} />
      <meta name="keywords" content={keywords || defaultKeywords} />
      <meta name="author" content="Alexandre SANOU" />
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || defaultDescription} />
      <meta property="og:image" content={image || defaultImage} />
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={currentLang === 'fr' ? 'fr_FR' : 'en_US'} />
      
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description || defaultDescription} />
      <meta name="twitter:image" content={image || defaultImage} />
      
      <meta name="geo.region" content="FR" />
      <meta name="geo.placename" content="Paris" />
    </Helmet>
  );
};

export default SEO;
